export function* watchGetRevenueChartsData() {
  // yield takeEvery(GET_REVENUE_CHARTS_DATA, getRevenueChartsData);
}

function* dashboardEcommerceSaga() {
  //yield all([fork(watchGetRevenueChartsData)]);
}

export default dashboardEcommerceSaga;
